<template>
  <div class="poll-listing">
    <div class="poll-container" v-for="poll in polls">
      <div class="poll-info">
        <p class="title">
          {{ poll.name }}
          <b-button variant="outline-danger" size="sm" class="poll-delete" @click="deletePoll(poll._id)">Poista</b-button>
        </p>
        <p class="poll-status">
          {{ pollStatus(poll.status) }}
        </p>

        <div class="poll-results">
          <div class="poll-result" v-for="choice in poll.choices">
            <p class="choice-name">{{ choice.name }}</p>
            <b-progress height="1.3rem">
              <b-progress-bar :value="choice.votes" :max="poll.vote_max">
                <span><strong>{{ choice.votes }}</strong> ({{ Math.round((choice.votes / poll.vote_max) * 100) }}%)</span>
              </b-progress-bar>
            </b-progress>
          </div>
        </div>
      </div>
      <div class="poll-actions">
        <b-button class="poll-cue" variant="success" size="sm" v-if="poll.status === 'active'" @click="cuePoll(poll._id)">
          Lopeta äänestys
        </b-button>
        <b-button class="poll-cue" variant="outline-dark" size="sm" v-if="poll.status === 'pending'" @click="cuePoll(poll._id)">
          Aloita äänestys
        </b-button>

        <div class="poll-data">
          <div v-if="poll.votes">Ääniä yhteensä <span class="badge badge-dark">{{ poll.votes.all_available || 0 }}</span></div>
          <div>Äänestäneet <span class="badge badge-dark">{{ voted(poll).length }}</span></div>
          <div v-if="poll.votes && poll.votes.online_users">
            Ei äänestäneet 
            <span class="badge badge-dark">
              {{ ( poll.votes.online_users.length - voted(poll).length ) }}
            </span>
          </div>
          <div class="poll-cutter" v-if="poll.votes && poll.cut_total">
            <p v-if="poll.votes.cut_users">
              Ääniä leikattu
              <span class="badge badge-dark">
                {{ poll.cut_total }}
              </span>
            </p>

            <p class="cutter-company" v-for="company in poll.votes.cut_users">
              {{ company.company }} <span class="badge">{{ company.cutVotes }}</span>
            </p>

            <div v-if="poll.votes" style="margin-top:1.5rem;">Leikkurin jälkeen <span class="badge badge-dark">{{ poll.votes.all_available - poll.cut_total }}</span></div>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PollListing',

  computed: {
    event () {
      return this.$store.state.event
    },
    polls () {
      const polls = this.$store.state.polls.filter(p => !p.isDeleted).slice()

      polls.forEach(poll => {
        if (!poll.answers) return 
        if (!poll.votes) poll.votes = { cut_users: [] }

        poll.vote_max = 0
        poll.cut_total = poll.votes.cut_users.reduce((acc, curr) => { return acc + parseInt(curr.cutVotes) }, 0)

        poll.choices.forEach(choice => {
          choice.votes = 0
        })

        poll.answers.forEach(answer => {
          const choice = poll.choices.find(c => c.id === answer.choice)
          choice.votes += answer.votesAllowed
          poll.vote_max += answer.votesAllowed
        })
      })

      return polls.reverse()
    },
    socket () {
      return this.$store.state.socket
    }
  },

  watch: {
    event () {
      this.getPolls()
    }
  },

  methods: {
    getPolls () {
      if (!this.event._id) return

      this.$store.dispatch('API_CALL', {
        method: 'get',
        url: `/events/${this.event._id}/polls`
      }).then((res) => {
        this.$store.commit('setPolls', res.data)
      })
    },

    pollStatus(status) {
      switch (status) {
        case 'pending': 
          return 'Äänestys odottaa'
          break;
        case 'active':
          return 'Äänestys käynnissä'
          break;
        case 'ended':
          return 'Äänestys päättynyt'
          break;
      }
    },

    voted (poll) {
      if (!poll.answers) return []

      const distinct = []
      poll.answers.forEach((answer) => {
        if (answer.isMandate) distinct.push(answer.mandateId)
        else distinct.push(answer.userId)
      })

      return [...new Set(distinct)]
    },

    cuePoll (id) {
      const hasActive = this.polls.find((poll) => poll.status === 'active');
      if(hasActive && hasActive.id !== id) this.socket.emit("cue_poll", hasActive.id);

      setTimeout(() => {
          this.socket.emit("cue_poll", id);
      }, 500)
    },

    deletePoll (id) {
        this.$store.dispatch("API_CALL", { method: "delete", url: `/events/${this.event._id}/polls`,
        data: { pollId: id }, headers: { ['x-access-token']: localStorage.adminToken }}).then((res) => {
            this.socket.emit("delete_poll", id);
        }).catch(err => {
            console.error(err);     
        })
    }
  }
}
</script>

<style scoped>
  .poll-container {
    position: relative;
    padding: 20px;
  }
  .poll-container hr {
    margin: 2rem 0;
  }
  .poll-info {
    display: inline-block;
    width: 70%;
    padding: 10px;
  }
  .poll-info .title {
    font-weight: 600;
    margin-bottom: 7px;
  }
  .poll-status {
    margin-bottom: 1.5rem;
    font-size: 14px;
  }
  .poll-actions {
    display: inline-block;
    width: 30%;
    position: absolute;
    text-align: center;
  }
  .poll-result {
    margin-bottom: 1rem;
  } 
  .choice-name {
    margin-bottom: 3px;
  }
  .poll-delete {
    padding: 0 0.5rem;
    margin-left: 10px;
  }
  .poll-cue {
    margin-bottom: 20px;
  }
  .cutter-company {
    margin: 0;
    font-size: 14px;
  }
  .poll-data {
    font-size: 14px;
  }
  .poll-data .badge {
    margin-left: 5px;
  }
</style>